function toMins(t) {
  if (!t) return null;
  const clean = t.replace(":", "");
  if (clean.length < 4) return null;
  const h = parseInt(clean.slice(0, 2), 10);
  const m = parseInt(clean.slice(2, 4), 10);
  if (isNaN(h) || isNaN(m)) return null;
  return h * 60 + m;
}

function parseShift(shiftStr) {
  if (!shiftStr) return null;
  const parts = shiftStr.replace(/[^0-9\-:]/g, "").split("-");
  if (parts.length !== 2) return null;
  const start = toMins(parts[0]);
  const end   = toMins(parts[1]);
  if (start === null || end === null) return null;
  return { start, end };
}

function calcSection(entry, shift) {
  if (!shift) return entry.section ?? "active";
  // Use best available inbound time: ATA > ETA > STA
  const inTime  = toMins(entry.ata || entry.sta);
  // Use best available outbound time: STD > ATD (excluding XCL)
  let outTime = toMins(entry.std || (entry.atd !== "XCL" ? entry.atd : null));
  // Adjust for next-day outbound (e.g. 00:05 STD when shift ends at 22:00):
  // if outbound appears before inbound and adding 24hrs gives a plausible connection, it's next-day
  if (outTime !== null && inTime !== null && outTime < inTime && outTime + 1440 - inTime < 480)
    outTime += 1440;
  // Post-shift if either inbound arrives after shift end OR outbound departs after shift end
  const inLate  = inTime  !== null && inTime  > shift.end;
  const outLate = outTime !== null && outTime > shift.end;
  return (inLate || outLate) ? "outlook" : "active";
}

function applyShiftToEntries(entries, shift) {
  return entries.map(e => ({ ...e, section: calcSection(e, shift) }));
}

function isValidShift(s) {
  return parseShift(s) !== null;
}

function formatShift(s) {
  if (!s) return "";
  const parts = s.replace(/[^0-9\-]/g, "").split("-");
  if (parts.length !== 2) return s;
  const fmt = t => t.length >= 4 ? t.slice(0,2) + ":" + t.slice(2,4) : t;
  return fmt(parts[0]) + " - " + fmt(parts[1]);
}

function calcConnTime(e) {
  if (e.cancelled || e.atd === "XCL") return null;
  const inTime  = e.ata || e.eta || e.sta;
  const outTime = e.atd || e.etd || e.std;
  if (!inTime || !outTime) return null;
  const [ah, am] = inTime.split(":").map(Number);
  const [dh, dm] = outTime.split(":").map(Number);
  if (isNaN(ah) || isNaN(dh)) return null;
  let diff = (dh * 60 + dm) - (ah * 60 + am);
  // If diff is negative, check if adding 24hrs gives a plausible connection (< 8 hrs).
  // If so, the outbound is next-day — otherwise it's a genuine miss.
  if (diff < 0 && diff + 1440 < 480) diff += 1440;
  return diff;
}

function fmtConn(mins) {
  if (mins === null || mins === undefined) return null;
  const abs = Math.abs(mins);
  const sign = mins < 0 ? "-" : "";
  // Use non-breaking spaces so the string never wraps in a narrow PDF column
  if (abs < 60) return sign + abs + "\u00A0min";
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  return sign + h + "\u00A0hr" + (m > 0 ? "\u00A0" + m + "\u00A0min" : "");
}

function getAirlineCode(airline, flight) {
  return (airline || (flight || "").slice(0, 2) || "").toUpperCase();
}

function formatDateLabel(dateStr) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  const month = date.toLocaleString("en-US", { month: "long" });
  const suffix = d === 1 || d === 21 || d === 31 ? "st"
    : d === 2 || d === 22 ? "nd"
    : d === 3 || d === 23 ? "rd" : "th";
  return `${month} ${d}${suffix}, ${y}`;
}

export { toMins, parseShift, calcSection, applyShiftToEntries, isValidShift, formatShift, calcConnTime, fmtConn, getAirlineCode, formatDateLabel };
